import React from 'react';
import { Typography, Paper, Box, Alert, AlertTitle } from '@mui/material';
import PageBackground from '../components/PageBackground';

const OcrReader: React.FC = () => {
  return (
    <PageBackground>
      <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 600, textShadow: 'none' }}>
        OCR Reader
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Alert severity="info" sx={{ mb: 3 }}>
          <AlertTitle>Development in Progress</AlertTitle>
          The OCR Tool is currently under development and will be available soon. Thank you for your patience.
        </Alert>
        <Paper sx={{ 
          p: 3, 
          backgroundColor: '#ffffff', 
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.06)',
          borderRadius: 2,
          border: '1px solid rgba(240, 240, 240, 0.9)',
        }}>
          <Typography variant="h6" gutterBottom>
            OCR Reader Module
          </Typography>
          <Typography paragraph>
            This module will provide optical character recognition functionality to extract text from images and documents.
          </Typography>
          <Typography paragraph>
            Upcoming features:
          </Typography>
          <ul>
            <li>
              <Typography>Upload image or PDF files for text extraction</Typography>
            </li>
            <li>
              <Typography>Automated data extraction and form filling</Typography>
            </li>
            <li>
              <Typography>Integration with other modules</Typography>
            </li>
          </ul>
        </Paper>
      </Box>
    </PageBackground>
  );
};

export default OcrReader; 